import React from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Container,
  IconButton,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
  Divider,
} from '@mui/material';
import { Menu as MenuIcon, Close as CloseIcon } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.svg';
import '../styles/styles.css';

const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isActive = (path) => location.pathname === path;

  const navigationItems = [
    { path: '/upload', label: 'Upload' },
    { path: '/files', label: 'Files' },
    { path: '/about', label: 'About' },
  ];

  return (
    <AppBar position="fixed" elevation={0} sx={{
      backgroundColor: 'rgba(255,255,255,0.85)',
      backdropFilter: 'blur(12px)',
      borderBottom: '1px solid rgba(108,99,255,0.1)',
      userSelect: 'none',
    }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ height: 64 }}>
          <Link to="/" style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            outline: 'none',
            WebkitTapHighlightColor: 'transparent',
          }}>
            <img src={logo} alt="Storify Logo" draggable="false" style={{
              width: 130, height: 'auto', pointerEvents: 'none', display: 'block',
            }} />
          </Link>

          <Box sx={{ flexGrow: 1 }} />

          {isMobile ? (
            <>
              <IconButton onClick={handleMenu} sx={{
                color: '#6C63FF',
                WebkitTapHighlightColor: 'transparent',
              }}>
                {Boolean(anchorEl) ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                  sx: {
                    borderRadius: '16px',
                    boxShadow: '0 12px 40px rgba(108,99,255,0.18)',
                    mt: 1,
                    minWidth: 180,
                    border: '1px solid rgba(108,99,255,0.1)',
                    overflow: 'hidden',
                    p: '6px',
                  }
                }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                {navigationItems.map((item, index) => (
                  <React.Fragment key={item.path}>
                    <MenuItem
                      component={Link}
                      to={item.path}
                      onClick={handleClose}
                      selected={isActive(item.path)}
                      sx={{
                        fontSize: '0.95rem',
                        fontWeight: isActive(item.path) ? 700 : 500,
                        color: isActive(item.path) ? '#6C63FF' : '#333',
                        borderRadius: '10px',
                        py: 1.2,
                        px: 2,
                        userSelect: 'none',
                        WebkitTapHighlightColor: 'transparent',
                        '&.Mui-selected': {
                          backgroundColor: 'rgba(108,99,255,0.08)',
                          '&:hover': { backgroundColor: 'rgba(108,99,255,0.12)' },
                        },
                        '&:hover': { backgroundColor: 'rgba(108,99,255,0.06)' },
                      }}
                    >
                      {item.label}
                    </MenuItem>
                    {index < navigationItems.length - 1 && (
                      <Divider sx={{ borderColor: 'rgba(108,99,255,0.06)', my: 0.5 }} />
                    )}
                  </React.Fragment>
                ))}
              </Menu>
            </>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {navigationItems.map((item) => (
                <Button
                  key={item.path}
                  component={Link}
                  to={item.path}
                  variant={isActive(item.path) ? 'contained' : 'text'}
                  sx={{
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    px: 2,
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    ...(isActive(item.path) ? {
                      backgroundColor: '#6C63FF',
                      color: '#fff',
                      boxShadow: 'none',
                      '&:hover': { backgroundColor: '#4B45B3', boxShadow: 'none' },
                    } : {
                      color: '#555',
                      '&:hover': { backgroundColor: 'rgba(108,99,255,0.06)', color: '#6C63FF' },
                    }),
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;